import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/CustomAuthContext';
import './Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>PRO Market History</h3>
          <p>Community-driven Pokemon Revolution Online price tracking</p>
        </div>

        <div className="footer-section">
          <h4>Information</h4>
          <div className="footer-links">
            <button onClick={() => navigate('/faq')} className="footer-link">
              FAQ
            </button>
            <button onClick={() => navigate('/impressum')} className="footer-link">
              Legal Notice
            </button>
          </div>
        </div>

        <div className="footer-section">
          <h4>Account</h4>
          <div className="footer-links">
            {user ? (
              <button onClick={() => navigate('/dashboard')} className="footer-link">
                Dashboard
              </button>
            ) : (
              <button onClick={() => navigate('/login')} className="footer-link">
                Login
              </button>
            )}
          </div>
        </div>

        <div className="footer-section">
          <h4>Contribute</h4>
          <div className="footer-links">
            {user ? (
              <button onClick={() => navigate('/submit-data')} className="footer-link">
                Submit Data
              </button>
            ) : (
              <button onClick={() => navigate('/login')} className="footer-link">
                Login to Submit
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 PRO Market History. Community project for Pokemon Revolution Online.</p>
        <p>Not affiliated with Pokemon Revolution Online.</p>
      </div>
    </footer>
  );
};

export default Footer;
